import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { HeadingDisplay } from '@warrenbrasil/nebraska-web';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';

interface Props {
  isLoading: boolean;
  portfolioName?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    isLoading: { type: Boolean },
    portfolioName: null
  },
  setup(__props: any) {

const props = __props as {
  isLoading: boolean;
  portfolioName?: string;
}



const portfolioName = computed(() => props.portfolioName || '-');

return { __sfc: true,props, portfolioName, HeadingDisplay, HeadingDisplayLoader }
}

})